import React from 'react';
import { FIELD_CONDITIONS } from '../config/media';

export const FieldConditions = () => (
    <section
        className="border-y border-brand-hairline bg-brand-base"
        data-testid="field-conditions"
    >
        <div className="mx-auto max-w-7xl px-6 py-20 md:px-10 md:py-28">
            <span className="eyebrow">Field Conditions</span>
            <h2 className="h-display mt-6 max-w-3xl text-3xl sm:text-4xl">
                Engineered for the ground that breaks everything else.
            </h2>
            <div className="mt-12 grid gap-4 md:grid-cols-3">
                {FIELD_CONDITIONS.map((c) => (
                    <figure
                        key={c.label}
                        className="group relative overflow-hidden border border-brand-hairline bg-brand-surface"
                    >
                        <div className="aspect-[5/4] w-full overflow-hidden">
                            {c.src ? (
                                <img
                                    src={c.src}
                                    alt={c.alt}
                                    loading="lazy"
                                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                                />
                            ) : null}
                        </div>
                        <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-brand-base via-brand-base/70 to-transparent p-5">
                            <span className="font-display text-xs font-bold uppercase tracking-[0.2em] text-brand-gold">
                                {c.label}
                            </span>
                        </figcaption>
                    </figure>
                ))}
            </div>
        </div>
    </section>
);

export default FieldConditions;
